// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "caption-1ahBc";
var _4 = "multiCity-1eOYi";
export { _1 as "__esModule", _2 as "mobile", _3 as "caption", _4 as "multiCity" }
export default { "__esModule": _1, "mobile": _2, "caption": _3, "multiCity": _4 }
